import React from "react";

import AppHeader from "../Header";

const Header = ({ description }) => (
  <AppHeader description={description}>
    <h2 className="mb-hf">Add your work references</h2>
  </AppHeader>
);

export default Header;
